import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../dropdown'
import DropZone from '../../dropzone'
import { FormSelectYesNo,  FormInputText, DateSelector, FormTextArea } from '../formelements'
import config from '../../../config'


export function EnrolmentFormMedicalData(props) {

  /* DADES GENERALS */
  const [ errors, setErrors ] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  const [dadesPersonals, setDadesPersonals ] = useState({validat: false});
  // gent que faci els 12 dins l'any - 1r ESO

  /* DADES PERSONALS */
  const [dadesIdentificativesOpen, setDadesIdentificativesOpen] = useState(true)
  const toggleOpen = () => {
        setDadesPersonals(false)

        handleDadesMediques(false)
        setDadesMediquesOpen(false)
        //setDadesMediques(false)

        handleDadesLaborals(false)
        setDadesLaboralsOpen(false)
        //setDadesLaborals(false)
    setDadesIdentificativesOpen(!dadesIdentificativesOpen)
  }

  /* DADES MEDIQUES */
  const [dadesMediquesOpen, setDadesMediquesOpen] = useState(true);
  const toggleDadesMediquesOpen = () => {
    setDadesMediquesOpen(!dadesMediquesOpen);
  }

  const [dadesMediques, setDadesMediques] = useState({validat: false});


  const [TSI, setTSI] = useState('');
  const [TSIFile, setTSIFile] = useState();
  const [llibreVacunacionsFile, setllibreVacunacionsFile] = useState();
  const [nSS, setnSS] = useState('');
  const [allergies, setAllergies] = useState();
  const [allergiesFile, setAllergiesFile] = useState();
  const [allergiesObservacions, setAllergiesObservacions] = useState('');
  const [malalties, setMalalties] = useState();
  const [malaltiesFile, setMalaltiesFile] = useState();
  const [malaltiesObservacions, setMalaltiesObservacions] = useState('');
  const [problemesVista, setProblemesVista] = useState();
  const [problemesVistaFile, setProblemesVistaFile] = useState();
  const [problemesVistaObservacions, setProblemesVistaObservacions] = useState('');
  const [problemesMobilitat, setProblemesMobilitat] = useState();
  const [problemesMobilitatFile, setProblemesMobilitatFile] = useState();
  const [problemesMobilitatObservacions, setProblemesMobilitatObservacions] = useState('');
  const [medicacio, setMedicacio] = useState();
  const [medicacioFile, setMedicacioFile] = useState();
  const [medicacioObservacions, setMedicacioObservacions] = useState('');
  const [problemesPsicologics, setProblemesPsicologics] = useState();
  const [problemesPsicologicsFile, setProblemesPsicologicsFile] = useState();
  const [problemesPsicologicsObservacions, setProblemesPsicologicsObservacions] = useState('');
  const [protocolEmergencia, setProtocolEmergencia] = useState();
  const [protocolEmergenciaObservacions, setProtocolEmergenciaObservacions] = useState('');

  const handleFileError = (e,msg) => {
    let err  = {...errors}
    err[e] = msg 
    setErrors(err)
  }

  /* VALIDA DADES MEDIQUES */
 const  validaTSI  = () => { return TSI.length > 0 ? null : "El camp no pot estar buit" }
 const  validaTSIFile  = () => {

  if(props.dadesPersonals.adjuntarArxiusNoObligatori) return null

  return TSIFile ? null : "El camp no pot estar buit."
}

 const  validaLlibreVacunacionsFile  = () => {

  if(props.dadesPersonals.adjuntarArxiusNoObligatori) return null

  return  llibreVacunacionsFile ? null : "El camp no pot estar buit."
}

 const  validanSS  = () => { return nSS.length > 0 ? null : "El camp no pot estar buit" }
 
 const  validaAllergies  = () => { return allergies ? null : "Heu triar un valor" }
 const  validaAllergiesFile  = () => { if(allergies === "1" && config.adjuntMedicObligatori ) { return allergiesFile ? null : "Heu triar un valor" } return null }
 const  validaAllergiesObservacions  = () => { if(allergies === "1") { return allergiesObservacions.length > 0 ? null : "El camp no pot estar buit" } return null }
 
 const  validaMalalties  = () => { return malalties ? null : "Heu triar un valor" }
 const  validaMalaltiesFile  = () => { if( malalties === "1" && config.adjuntMedicObligatori ) { return malaltiesFile ? null : "Heu d'adjuntar un arxiu" } return null }
 const  validaMalaltiesObservacions  = () => { if( malalties === "1") { return malaltiesObservacions.length > 0 ? null : "El camp no pot estar buit" } return null }
 
 const  validaProblemesVista  = () => { return problemesVista ? null : "Heu triar un valor" }
 const  validaProblemesVistaFile  = () => { if( problemesVista === "1" && config.adjuntMedicObligatori ) { return problemesVistaFile ? null : "Heu d'adjuntar un arxiu" } return null }
 const  validaProblemesVistaObservacions  = () => { if( problemesVista === "1") { return problemesVistaObservacions.length > 0 ? null : "El camp no pot estar buit" } return null }
 
 const  validaProblemesMobilitat  = () => { return problemesMobilitat ? null : "Heu triar un valor" }
 const  validaProblemesMobilitatFile  = () => { if( problemesMobilitat === "1" && config.adjuntMedicObligatori ) { return problemesMobilitatFile ? null : "Heu d'adjuntar un arxiu" } return null }
 const  validaProblemesMobilitatObservacions  = () => { if( problemesMobilitat === "1") { return problemesMobilitatObservacions.length > 0 ? null : "El camp no pot estar buit" } return null }
 
 const  validaMedicacio  = () => { return medicacio ? null : "Heu triar un valor" }
 const  validaMedicacioFile  = () => { if( medicacio === "1" && config.adjuntMedicObligatori ) { return medicacioFile ? null : "Heu d'adjuntar un arxiu" } return null }
 const  validaMedicacioObservacions  = () => { if( medicacio === "1") { return medicacioObservacions.length > 0 ? null : "Heu triar un valor" } return null }

 const  validaProblemesPsicologics  = () => { return problemesPsicologics ? null : "Heu triar un valor" }
 const  validaProblemesPsicologicsFile  = () => { if( problemesPsicologics === "1" && config.adjuntMedicObligatori ) { return problemesPsicologicsFile ? null : "Heu d'adjuntar un arxiu" } return null }
 const  validaProblemesPsicologicsObservacions  = () => { if( problemesPsicologics === "1") { return problemesPsicologicsObservacions.length > 0 ? null : "Heu triar un valor" } return null }

 const  validaProtocolEmergencia  = () => { return protocolEmergencia ? null : "Heu triar un valor" }
 const  validaProtocolEmergenciaObservacions  = () => { if( protocolEmergencia === "1") { return protocolEmergenciaObservacions.length > 0 ? null : "Heu triar un valor" } return null }


const validaMediques = (e) => {
  e.preventDefault();

  let error = {}

  error.TSI = validaTSI();
  handleErrors('TSI',error)

  error.TSIFile = validaTSIFile()
  handleErrors('TSIFile', error)

  if(config.llibreVacunacions)
  {
  error.llibreVacunacionsFile = validaLlibreVacunacionsFile()
  handleErrors('llibreVacunacionsFile', error)
  }

 /* no és obligatori
  error.nSS = validanSS()
  handleErrors('nSS', error)
 */

  error.allergies = validaAllergies()
  handleErrors('allergies', error)

  error.allergiesFile = validaAllergiesFile()
  handleErrors('allergiesFile', error)

  error.allergiesObservacions = validaAllergiesObservacions()
  handleErrors('allergiesObservacions', error)

  error.malalties = validaMalalties()
  handleErrors('malalties', error)

  error.malaltiesFile = validaMalaltiesFile()
  handleErrors('malaltiesFile', error)

  error.malaltiesObservacions = validaMalaltiesObservacions()
  handleErrors('malaltiesObservacions', error)

  error.problemesVista = validaProblemesVista()
  handleErrors('problemesVista', error)

  error.problemesVistaFile = validaProblemesVistaFile()
  handleErrors('problemesVistaFile', error)

  error.problemesVistaObservacions = validaProblemesVistaObservacions()
  handleErrors('problemesVistaObservacions', error)

  error.problemesMobilitat = validaProblemesMobilitat()
  handleErrors('problemesMobilitat', error)

  error.problemesMobilitatFile = validaProblemesMobilitatFile()
  handleErrors('problemesMobilitatFile', error)

  error.problemesMobilitatObservacions = validaProblemesMobilitatObservacions()
  handleErrors('problemesMobilitatObservacions', error)

  error.medicacio = validaMedicacio()
  handleErrors('medicacio', error)

  error.medicacioFile = validaMedicacioFile()
  handleErrors('medicacioFile', error)

  error.medicacioObservacions = validaMedicacioObservacions()
  handleErrors('medicacioObservacions', error) 


  if( config.problemesPsicologics === true)
  {
  error.problemesPsicologics = validaProblemesPsicologics()
  handleErrors('problemesPsicologics', error)

  error.problemesPsicologicsFile = validaProblemesPsicologicsFile()
  handleErrors('problemesPsicologicsFile', error)

  error.problemesPsicologicsObservacions = validaProblemesPsicologicsObservacions()
  handleErrors('problemesPsicologicsObservacions', error) 
  }

  if( config.protocolEmergencia === true)
  {
  error.protocolEmergencia = validaProtocolEmergencia()
  handleErrors('protocolEmergencia', error)

  error.protocolEmergenciaObservacions = validaProtocolEmergenciaObservacions()
  handleErrors('protocolEmergenciaObservacions', error) 
  }


  setErrors(error)

  let noError = true;
  //DEVELOP if (window.location.hostname !== "localhost" ) Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
  if(!config.develop) // bypass errors if develop == true
  {
    Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
  }

  console.log('ERROR',error);

  handleDadesMediques(noError)

  if(noError)
  {
      setDadesIdentificativesOpen(false)
      setDadesMediquesOpen(false)
        setDadesLaboralsOpen(true)
        /*
      if(edat>=16)
      {
        setDadesLaboralsOpen(true)
      }
      else
      {
          // #NOTREBALLA : ALUMNES ESO I MENORS DE 16 EN GENERAL NO PODEN HAVER TREBALLAT SALTEM APARTAT
        setDadesLaboralsOpen(false)
        handleDadesLaborals(true)
      }
        */
  }

  return false;
}

  const handleDadesPersonals = (noError) => {

    let d =  {...dadesPersonals, validat: noError}

    setDadesPersonals(d)
    props.handleDadesPersonals(d)
  }

  const handleDadesMediques = (noError) => {

  let d = {
   "validat": noError,
  /* DADES MEDIQUES */

  "TSI": TSI , 
  "TSIFile": TSIFile , 
  "nSS": nSS , 
  "allergies": allergies , 
  "allergiesFile": allergiesFile , 
  "allergiesObservacions": allergiesObservacions , 
  "malalties": malalties , 
  "malaltiesFile": malaltiesFile , 
  "malaltiesObservacions": malaltiesObservacions , 
  "problemesVista": problemesVista , 
  "problemesVistaFile": problemesVistaFile , 
  "problemesVistaObservacions": problemesVistaObservacions , 
  "problemesMobilitat": problemesMobilitat , 
  "problemesMobilitatFile": problemesMobilitatFile , 
  "problemesMobilitatObservacions": problemesMobilitatObservacions , 
  "medicacio": medicacio , 
  "medicacioFile": medicacioFile , 
  "medicacioObservacions": medicacioObservacions,
  "problemesPsicologics": problemesPsicologics, 
  "problemesPsicologicsFile": problemesPsicologicsFile, 
  "problemesPsicologicsObservacions": problemesPsicologicsObservacions,
  "protocolEmergencia": protocolEmergencia, 
  "protocolEmergenciaObservacions": protocolEmergenciaObservacions  
  }

    //console.log("DADES_MEDIQUES",d)
    setDadesMediques(d)
    props.handleDadesMediques(d)
  }


// VALIDA 


  /* DADES LABORALS */
  const [dadesLaboralsOpen, setDadesLaboralsOpen] = useState(false);
  const toggleDadesLaboralsOpen = () => {
    setDadesLaboralsOpen(!dadesLaboralsOpen);
  }
  const [dadesLaborals, setDadesLaborals] = useState({validat: false});

  const handleDadesLaborals = (noError) => {

    let d =  {...dadesLaborals, validat: noError}

    setDadesLaborals(d)
    props.handleDadesLaborals(d)
  }


  /* DADES MEDIQUES */
  return (
    <div className="container">

      <div className="container">
        <div className="row">
          <div className="col col-12 ">
            <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
              <div className="t-Region-header">
                <div className="t-Region-headerItems  t-Region-headerItems--controls">
                  <button className="t-Button t-Button--icon t-Button--hideShow" type="button" onClick={toggleDadesMediquesOpen}>
                    {dadesMediquesOpen && <FontAwesomeIcon icon={faChevronUp} fontSize="18" className="t-Icon" />}
                    {!dadesMediquesOpen && <FontAwesomeIcon icon={faChevronDown} fontSize="18" className="t-Icon" />}
                  </button>
                </div>
                <div className="t-Region-headerItems t-Region-headerItems--title">
                  <h2 className="t-Region-title a-Collapsible-heading">Dades mèdiques</h2>
                </div>
                <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
              </div>
              <div className="t-Region-bodyWrap">

                <Dropdown open={dadesMediquesOpen}>
                  <div className="t-Region-body a-Collapsible-content">

                    <div className="container">
                      <div className="row">
                        <div className="col col-12 ">
                          <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                            <div className="t-Region-bodyWrap">
                              <div className="t-Region-body">
                                <div className="container">
                                  <div className="row">


                                    <FormInputText id="TSI" name="TSI" col="col-3" label="Targeta Sanitaria Individual (TSI)" obligatori={true} size="20" maxLength="15" value={TSI} onChange={setTSI} error={errors.TSI} />

                                    <DropZone id="TSIFile" file={TSIFile} onChange={setTSIFile} label="Adjuntar TSI (davant)" obligatori={!props.dadesPersonals.adjuntarArxiusNoObligatori} labelDrop="adjuntar document" error={errors.TSIFile}  handleFileError={ (msg) =>handleFileError('TSIFile',msg) }  />

                                    <div className="col col-1">&nbsp;</div>

                                    <FormInputText id="nSS" name="nSS" col="col-3" label="Nº Seguretat Social" obligatori={false} size="20" maxLength="15" value={nSS} onChange={setnSS} error={errors.nSS} />

                                  </div>

                                  <br/>


                                  {config.llibreVacunacions && (
                                    <>
                                      <div className="row">
                                        <div className="col col-4 ">
                                          <DropZone id="llibreVacunacionsFile" file={llibreVacunacionsFile} onChange={setllibreVacunacionsFile} label="Adjuntar llibre vacunacions" obligatori={!props.dadesPersonals.adjuntarArxiusNoObligatori} labelDrop="adjuntar document" error={errors.llibreVacunacionsFile} handleFileError={(msg) => handleFileError('llibreVacunacionsFile', msg)} />
                                        </div>
                                      </div>
                                      <br />
                                    </>
                                  )}

                                  <div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="allergies"
                                        name="allergies"
                                        col="col-3"
                                        label="Al·lèrgies o intoleràncies"
                                        obligatori={true}
                                        value={allergies}
																				error={errors.allergies}
                                        file={allergiesFile}
                                        handleChange={(e) => setAllergies(e.target.value)} />

                                      {allergies === "1" && <FormTextArea id="allergiesObservacions" name="allergiesObservacions" col="col-5" obligatori={true}  label="Observacions" value={allergiesObservacions} rows="5" cols="80" maxLength="1000" onChange={setAllergiesObservacions} error={errors.allergiesObservacions} />}
                                      { ( allergies === "1" && config.adjuntMedic ) && <DropZone id="allergiesFile" file={allergiesFile} onChange={setAllergiesFile} obligatori={config.adjuntMedicObligatori}  label="Adjuntar document" labelDrop="adjuntar document" error={errors.allergiesFile}   handleFileError={ (msg) =>handleFileError('allergiesFile',msg) } />}

                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="malalties"
                                        name="malalties"
                                        col="col-3"
                                        label="Malalties greus"
                                        obligatori={true}
                                        value={malalties}
																				error={errors.malalties}
                                        file={malaltiesFile}
                                        handleChange={(e) => setMalalties(e.target.value)} />

                                      {malalties === "1" && <FormTextArea id="malaltiesObservacions" name="malaltiesObservacions" col="col-5" obligatori={true}  label="Observacions" value={malaltiesObservacions} rows="5" cols="80" maxLength="1000" onChange={setMalaltiesObservacions} error={errors.malaltiesObservacions} />}
                                      { ( malalties === "1" && config.adjuntMedic ) && <DropZone id="malaltiesFile" file={malaltiesFile} onChange={setMalaltiesFile} obligatori={config.adjuntMedicObligatori}  label="Adjuntar document" labelDrop="adjuntar document" error={errors.malaltiesFile}  handleFileError={ (msg) =>handleFileError('malaltiesFile',msg) }  />}

                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="problemesVista"
                                        name="problemesVista"
                                        col="col-3"
                                        label="Problemes de vista/oïda?"
                                        obligatori={true}
                                        value={problemesVista}
																				error={errors.problemesVista}
                                        file={problemesVistaFile}
                                        handleChange={(e) => setProblemesVista(e.target.value)} />

                                      {problemesVista === "1" && <FormTextArea id="problemesVistaObservacions" name="problemesVistaObservacions" obligatori={true} col="col-5" label="Observacions" value={problemesVistaObservacions} rows="5" cols="80" maxLength="1000" onChange={setProblemesVistaObservacions} error={errors.problemesVistaObservacions} />}
                                      { ( problemesVista === "1" && config.adjuntMedic ) && <DropZone id="problemesVistaFile" file={problemesVistaFile} obligatori={config.adjuntMedicObligatori} onChange={setProblemesVistaFile} label="Adjuntar document" labelDrop="adjuntar document" error={errors.problemesVistaFile} handleFileError={ (msg) =>handleFileError('problemesVistaFile',msg) }  />}

                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="problemesMobilitat"
                                        name="problemesMobilitat"
                                        col="col-3"
                                        label="Problemes de mobilitat?"
                                        obligatori={true}
                                        value={problemesMobilitat}
																				error={errors.problemesMobilitat}
                                        file={problemesMobilitatFile}
                                        handleChange={(e) => setProblemesMobilitat(e.target.value)} />

                                      {problemesMobilitat === "1" && <FormTextArea id="problemesMobilitatObservacions" name="problemesMobilitatObservacions" col="col-5" obligatori={true} label="Observacions" value={problemesMobilitatObservacions} rows="5" cols="80" maxLength="1000" onChange={setProblemesMobilitatObservacions} error={errors.problemesMobilitatObservacions} />}
                                      { (problemesMobilitat === "1" && config.adjuntMedic )  && <DropZone id="problemesMobilitatFile" file={problemesMobilitatFile} onChange={setProblemesMobilitatFile} obligatori={config.adjuntMedicObligatori}  label="Adjuntar document" labelDrop="adjuntar document" error={errors.problemesMobilitatFile}  handleFileError={ (msg) =>handleFileError('problemesMobilitatFile',msg) } />}

                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="prensMedicacio"
                                        name="prensMedicacio"
                                        col="col-3"
                                        label="Prens alguna medicació?"
                                        obligatori={true}
                                        value={medicacio}
																				error={errors.medicacio}
                                        file={medicacioFile}
                                        handleChange={(e) => setMedicacio(e.target.value)} />

                                      {medicacio === "1" && <FormTextArea id="medicacioObservacions" name="medicacioObservacions" obligatori={true} col="col-5" label="Observacions" value={medicacioObservacions} rows="5" cols="80" maxLength="1000" onChange={setMedicacioObservacions} error={errors.medicacioObservacions} />}
                                      { (medicacio === "1" && config.adjuntMedic ) && <DropZone id="medicacioFile" file={medicacioFile} onChange={setMedicacioFile} obligatori={config.adjuntMedicObligatori}  label="Adjuntar document" labelDrop="adjuntar document" error={errors.medicacioFile}  handleFileError={ (msg) =>handleFileError('medicacioFile',msg) } />}

                                    </div>
                                  </div>

                                  { config.problemesPsicologics === true &&
                                  (<div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="problemesPsicologics"
                                        name="problemesPsicologics"
                                        col="col-3"
                                        label="Problemes psicològics que puguin dificultar l'aprenentatge?"
                                        obligatori={true}
                                        value={problemesPsicologics}
																				error={errors.problemesPsicologics}
                                        file={medicacioFile}
                                        handleChange={(e) => setProblemesPsicologics(e.target.value)} />

                                      {problemesPsicologics === "1" && <FormTextArea id="problemesPsicologicsObservacions" name="problemesPsicologicsObservacions" obligatori={true} col="col-5" label="Observacions" value={problemesPsicologicsObservacions} rows="5" cols="80" maxLength="1000" onChange={setProblemesPsicologicsObservacions} error={errors.problemesPsicologicsObservacions} />}
                                      { (problemesPsicologics === "1" && config.adjuntMedic ) && <DropZone id="problemesPsicologicsFile" file={problemesPsicologicsFile} onChange={setProblemesPsicologicsFile} obligatori={config.adjuntMedicObligatori}  label="Adjuntar document" labelDrop="adjuntar document" error={errors.problemesPsicologicsFile}  handleFileError={ (msg) =>handleFileError('problemesPsicologicsFile',msg) } />}

                                    </div>
                                  </div>)}

                                  { config.protocolEmergencia === true &&
                                  (<div className="row">
                                    <div className="col col-12 ">

                                      <FormSelectYesNo id="protocolEmergencia"
                                        name="protocolEmergencia"
                                        col="col-3"
                                        label="Protocols d’actuació en cas d’emergència?"
                                        obligatori={true}
                                        value={protocolEmergencia}
																				error={errors.protocolEmergencia}
                                        handleChange={(e) => setProtocolEmergencia(e.target.value)} />

                                      {protocolEmergencia === "1" && <FormTextArea id="protocolEmergenciaObservacions" name="protocolEmergenciaObservacions" obligatori={true} col="col-5" label="Observacions/Procediment" value={protocolEmergenciaObservacions} rows="5" cols="80" maxLength="1000" onChange={setProtocolEmergenciaObservacions} error={errors.protocolEmergenciaObservacions} />}

                                    </div>
                                  </div>)}


                                </div>

                              </div>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>


                    { ( allergies === "1" || malalties === "1" || problemesVista === "1" || problemesMobilitat === "1" || medicacio === "1" ) &&
                    (<div className="container">
                      <div className="row">
                        <div className="col col-12">
                          <div class="t-Form-labelContainer" style={{ float: 'none', textAlign: 'center' }}>
                            <label class="t-Form-label">
                              {config.textDadesMediquesAlgunSi}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>)}


                  <div className="container">
                    <div className="row">
                      <div className="col col-12" align="center">
                        <button onClick={validaMediques} className="button">SEGÜENT</button>
                      </div>
                    </div>
                  </div>

                </Dropdown>
              </div>
            </div>

          </div>
        </div>



      </div>

    </div>
  );
}